module.exports = __webpack_public_path__ + "images/default_avatars/cloud@2x-f60be3c47f3ea33d0e10dc27ad07dd7c.jpg";